import { IS_ELECTRON_APP } from '../config/electron';

export const APP_PAUSE_STORAGE_KEY = '_app_paused';
export const AUTH_FAIL_MAX_ATTEMPTS = 5;
export const AUTH_FAIL_STORAGE_KEY = '_auth_fails_count';

export function setAppPaused(shouldPause = true) {
    if (shouldPause) {
        localStorage.setItem(APP_PAUSE_STORAGE_KEY, '1');
        return;
    }

    localStorage.removeItem(APP_PAUSE_STORAGE_KEY);
}

export function isAppPaused() {
    return !IS_ELECTRON_APP && !!localStorage.getItem(APP_PAUSE_STORAGE_KEY);
}

export function hasExceededAuthFailLimit() {
    const failCount = Number(localStorage.getItem(AUTH_FAIL_STORAGE_KEY)) || 0;
    return failCount >= AUTH_FAIL_MAX_ATTEMPTS;
}

export function updateAuthFailCount(count: number) {
    localStorage.setItem(AUTH_FAIL_STORAGE_KEY, String(count));
}

export function incrementAuthFailCount() {
    const currentCount = Number(localStorage.getItem(AUTH_FAIL_STORAGE_KEY)) || 0;
    updateAuthFailCount(currentCount + 1);
}

export function resetAuthFailCount() {
    localStorage.removeItem(AUTH_FAIL_STORAGE_KEY);
}
